import { useState } from 'react';
import { useIntl } from 'react-intl';
import type { TranslationType } from '@kiwicom/account-consts';
import { Visibility, VisibilityOff } from '@kiwicom/orbit-components/icons';

import ButtonLink from './Buttons/ButtonLink';
import InputField from './InputField';

type Props = {
  readonly label: TranslationType;
  readonly name: string;
};

const PasswordInput = ({ label, name }: Props): JSX.Element => {
  const [isPasswordVisible, setPasswordVisibility] = useState(false);
  const intl = useIntl();

  const togglePasswordVisibility = () => {
    setPasswordVisibility((oldState) => !oldState);
  };

  const showPassword = intl.formatMessage({
    id: 'account_v2.settings.account_settings.login.change_password_modal.sr_only.show_password',
    defaultMessage: 'Show password',
    description:
      'This text will be announced by screen readers. Screenshot: settings.account_settings.login.change_password_errors.jpg',
  });
  const hidePassword = intl.formatMessage({
    id: 'account_v2.settings.account_settings.login.change_password_modal.sr_only.hide_password',
    defaultMessage: 'Hide password',
    description:
      'This text will be announced by screen readers. Screenshot: settings.account_settings.login.change_password_errors.jpg',
  });

  return (
    <InputField
      type={isPasswordVisible ? 'text' : 'password'}
      name={name}
      label={label}
      suffix={
        <ButtonLink
          compact
          onClick={togglePasswordVisibility}
          iconLeft={isPasswordVisible ? <Visibility /> : <VisibilityOff />}
          title={isPasswordVisible ? hidePassword : showPassword}
        />
      }
    />
  );
};

export default PasswordInput;
